// Schalter „Für Mieter freigeben“ (Mieter-Seite › Dokumente). Seit #607 über setze_portal_freigabe auf die
// Tabelle dokument_freigaben: an = zugeordneter Mieter (sonst alle Mieter des Objekts), aus = alle Mieter-Freigaben weg.
// Die volle Auswahl (mehrere Mieter, Einheiten, Eigentümer) bietet der Freigabe-Dialog in der Dokument-Vorschau.
import { setzePortalFreigabe } from '../../lib/dokumente/portalFreigabe';

/** Setzt das Häkchen; liefert eine Fehlermeldung oder null. */
export function setzeMieterFreigabe(dokumentId: string, an: boolean): Promise<string | null> {
  return setzePortalFreigabe(dokumentId, 'mieter', an);
}
